@use "variables" as *;

.item {
  border-radius: 12px;
}

.container {
  width: 100%;
  display: flex;
}

.actionArea {
  display: flex;
  flex-grow: 1;
  height: 100%;
  padding: $spacing-s $spacing-l !important;
}

.positionContainer {
  width: fit-content !important;
}

.name {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: left;
  align-self: center;
}

.discountBox {
  margin-left: $spacing-s;
}

.price {
  text-align: right;
  margin-left: $spacing-s;
  white-space: nowrap;
}

.oldPrice {
  font-size: $fontSize-xxs;
  text-decoration-line: line-through;
  font-weight: lighter;
}

.newPrice {
  font-size: $fontSize-s;
  font-weight: bold;
}

.description {
  font-size: $fontSize-xs;
  font-weight: normal;
  white-space: pre-wrap;
  width: 100%;
  text-align: left;
  vertical-align: top;
}
